module.exports = __webpack_public_path__ + "static/media/galerija_2019 (28).6f88091f.jpg";